// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"6d71bcbd","879":"2bd41cec"}[chunkId] + ".chunk.js";
};